module.exports = __webpack_public_path__ + "static/media/ripan.3d12595d.png";